// src/components/PersistSessionParams.tsx
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getSessionParams } from '../utils/sessionParams';

/** Encode value nhưng giữ nguyên ký tự '@' trên URL */
const encodeValueKeepAt = (v: string) => encodeURIComponent(v).replace(/%40/g, '@');

/** Stringify URLSearchParams: encode key bình thường, value encode nhưng giữ '@' */
const stringifyKeepAt = (params: URLSearchParams) =>
  Array.from(params.entries())
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeValueKeepAt(v)}`)
    .join('&');

/**
 * Khi người dùng load thẳng URL, component này sẽ kiểm tra:
 * - Nếu URL CHƯA có một param nào đó từ session -> tự bổ sung vào URL (replace, không tạo lịch sử)
 * - Nếu URL đã có key đó -> giữ nguyên, không ghi đè
 */
export default function PersistSessionParams() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const session = getSessionParams(); // đã decode sẵn nếu bạn làm ở utils
    const urlParams = new URLSearchParams(location.search);
    let changed = false;

    Object.entries(session).forEach(([k, v]) => {
      if (!v) return;
      if (!urlParams.has(k)) {
        urlParams.set(k, String(v)); // để dạng thuần (có @)
        changed = true;
      }
    });
    const pathNoSlash = location.pathname.replace(/\/+$/, '');

    if (changed && pathNoSlash.endsWith('top')) {
      const search = stringifyKeepAt(urlParams); // ⬅️ KHÔNG dùng urlParams.toString()
      navigate(
        { pathname: location.pathname, search: search ? `?${search}` : '' },
        { replace: true }
      );
    }else if(pathNoSlash.endsWith('login')){
      sessionStorage.setItem('groupId',localStorage.getItem('groupId') ?? '')
      sessionStorage.setItem('groupIdDefault',localStorage.getItem('groupIdDefault') ?? '')
    }
    // Chạy lại khi đổi pathname (không spam khi chỉ đổi search)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return null;
}
